/**
 * Status do agendamento/visita conforme andamento do processo (1–6).
 * Usado em lista de solicitações, agenda, check list, histórico e dados da visita.
 */
export const STATUS_VISITA = {
  1: "Solicitação",
  2: "Solicitação",
  3: "Solicitação",
  4: "Check-in",
  5: "Acompanhamento",
  6: "Check-out",
};

export function textoStatus(status, cancelada) {
  if (cancelada) return "Cancelada";
  return STATUS_VISITA[status] ?? "—";
}

export function classeStatus(status, cancelada) {
  if (cancelada) return "status-cancelada";
  if (status >= 6) return "status-concluido";
  if (status >= 5) return "status-em-visita";
  if (status >= 4) return "status-confirmada";
  if (status >= 3) return "status-processo";
  return "status-pendente";
}
